import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { getDefaultPlayerMarker } from 'helpers/ArrayHelpers';
import { SqPlayer } from 'types/SqGame.types';

export const playerToDoc = (player: SqPlayer): DocumentData => {
  return {
    id: player.id,
    gameId: player.gameId,
    name: player.name,
    numberOfPicks: player.numberOfPicks,
    picks: player.picks,
    marker: player.marker,
    winningQuarters: player.winningQuarters,
    isAdmin: player.isAdmin,
    isBanned: player.isBanned ?? false,
    createdOn: player.createdOn,
  };
};

export const playerConverter: FirestoreDataConverter<SqPlayer> = {
  toFirestore(player: SqPlayer): DocumentData {
    // return { ...gameToDoc(game), ...getModifiedInfo() };
    return playerToDoc(player);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): SqPlayer {
    const player = docSnap.data(options);

    return {
      id: player.id,
      gameId: player.gameId,
      name: player.name,
      numberOfPicks: player.numberOfPicks,
      picks: player.picks,
      marker: player.marker
        ? { markerIndex: player.marker.markerIndex, markerValue: player.marker.markerValue }
        : getDefaultPlayerMarker(),
      winningQuarters: player.winningQuarters,
      isAdmin: player.isAdmin,
      isBanned: player.isBanned ?? false,
      createdOn: player.createdOn,
    };
  },
};
